<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Navigation from "./Navigation.svelte"
  import { appStore } from "$app/store.svelte"

  import bg from "@images/onboarding/bg-eclipse.jpg"

  let { onUpdateStep, onUpdateUser } = $props()

  let errors = $state({})

  let saving = $state(false)
  async function updateUser() {
    saving = true
    errors = {}
    const formData = new FormData()
    formData.append("user[onboarding_steps][activity]", "true")
    try {
      const resp = await xhr.patch(
        `/user_onboarding/${appStore.current_user.id}`,
        formData
      )
      onUpdateUser(resp.data)
    } catch (e) {
      console.error(e.response)
      toast("There was an error", "error")
      if (e.response) {
        errors = { ...errors, ...e.response.data.errors }
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="w-full">
  <div class="px-4 lg:px-6 pt-4 w-full pb-8 lg:pb-12 lg:text-left">
    <Navigation step="activity" {onUpdateStep} />
  </div>
  <div class="relative">
    <div class="mx-auto px-2 lg:px-6 w-full pb-6 lg:pb-12 lg:text-left">
      <div class="px-4 w-full lg:w-1/2 xl:w-5/12 xl:pr-16">
        <h2 class="text-3xl md:text-4xl font-bold text-left text-white">
          Activity Page
        </h2>

        <p class="mt-4 md:mt-6 text-lg text-white leading-6">
          The Activity Page is a place where all the components of your
          organization's plan come together. Here you can see <span
            class="italic">leadership development</span
          >
          through
          <span class="font-bold"
            >book readings, recent recognitions, and progress updates</span
          > on your quarterly goals from the last week.
        </p>
        <p class="mt-2 md:mt-4 text-lg text-white leading-6">
          Every week you will receive an email reminder to enter your <span
            class="font-bold text-green-200">progress updates</span
          >
          for your quarterly goals on the
          <span class="font-bold">Activity page</span>. The day of your
          <span class="font-bold">Weekly Meeting</span>
          the Activity page is summarized, copied and shared with the entire team
          <span class="font-bold">via email</span>. This process
          <span class="italic">keeps everyone on one page</span> and supports understanding
          where the focus needs to be on your goals at the start of your week.
        </p>

        <div
          class="relative w-full block lg:hidden mt-4 border border-gray-600"
        >
          <video playsinline autoplay loop muted preload="metadata">
            <source
              src="https://leadwithpurpose-web.s3.amazonaws.com/onboarding/activity_page.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div
          class="space-y-8 mt-4 lg:mt-8 max-w-md mx-auto flex justify-center"
        >
          <div class="py-4">
            <Button
              onclick={updateUser}
              processing={saving}
              class="btn-rounded bg-green-600 hover:bg-green-700 text-white btn-big w-full text-lg font-bold md:w-60 h-14"
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="hidden lg:inline-block lg:absolute lg:inset-y-0 lg:-right-0 lg:w-1/2 xl:w-7/12 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
      style="background-image: url({bg});"
    >
      <div class="absolute inset-0 w-full p-2">
        <video
          autoplay
          playsinline
          loop
          muted
          preload="metadata"
          class="shadow-lg border border-gray-400"
        >
          <source
            src="https://leadwithpurpose-web.s3.amazonaws.com/onboarding/activity_page.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</div>
